export const buildSpousalData = (uuid: string) => ({ child: false, userId: uuid });

export const isUniqueEmail = (email: string, relatedEmails: string[]) =>
  !relatedEmails.find((relatedEmail) => relatedEmail?.toLowerCase() === email.toLowerCase());
